import React from "react";
import { company } from "../mock";
import { Navigation, Lock, LifeBuoy, Scale, HelpCircle, Mail, MapPin, Images } from "lucide-react";

const Col = ({ title, children }) => (
  <div><p className="text-xs font-semibold tracking-widest text-neutral-500 uppercase mb-3">{title}</p><div className="flex flex-col gap-2">{children}</div></div>
);
const L = ({ href, testid, icon: Icon, children }) => (
  <a href={href} data-testid={testid} className="flex items-center gap-1.5 text-sm text-neutral-300 hover:text-brand transition-colors">{Icon && <Icon size={14} />} {children}</a>
);

/** Pied de page : coordonnées, informations légales / pratiques, accès collaborateurs. Les services sont dans le menu haut. */
const Footer = () => (
  <footer className="bg-neutral-950 border-t border-neutral-800 text-neutral-400">
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
      <div>
        <img src="/logo.png" alt="PTITSERVICES-PRO" className="h-9 w-auto rounded-md" data-testid="footer-logo" />
        <p className="text-sm mt-3">{company.tagline}</p>
        <p className="text-sm mt-3 flex items-start gap-1.5"><MapPin size={14} className="mt-0.5 shrink-0" /> {company.address}</p>
        <a href={`mailto:${company.email}`} className="text-sm flex items-center gap-1.5 mt-1 hover:text-brand"><Mail size={14} /> {company.email}</a>
      </div>
      <Col title="Informations">
        <L href="/mentions-legales" testid="footer-mentions" icon={Scale}>Mentions légales & confidentialité</L>
        <L href="/#faq" testid="footer-faq" icon={HelpCircle}>Questions fréquentes</L>
        <L href="/#devis" testid="footer-devis">Demander un devis</L>
        <L href="/#contact" testid="footer-contact">Nous contacter</L>
      </Col>
      <Col title="Clients">
        <L href="/ticket" testid="footer-ticket" icon={LifeBuoy}>Service client / Ticket</L>
        <L href="/qualite" testid="footer-qualite">Démarche qualité</L>
        <L href="/realisations" testid="footer-realisations" icon={Images}>Nos réalisations (avant / après)</L>
        <L href="/villes" testid="footer-villes" icon={MapPin}>Villes desservies (Grand Nord)</L>
      </Col>
      <Col title="Accès collaborateurs">
        <L href="/app" testid="footer-espace-intervenant" icon={Navigation}>Espace intervenant</L>
        <L href="/admin" testid="footer-espace-crm" icon={Lock}>Espace CRM</L>
        <L href="/recrutement" testid="footer-recrutement">Nous rejoindre</L>
      </Col>
    </div>
    <div className="border-t border-neutral-800/70">
      <p className="max-w-7xl mx-auto px-5 md:px-8 py-4 text-xs text-neutral-500 text-center md:text-left">
        © {new Date().getFullYear()} {company.domain} · Accès collaborateurs sécurisé par connexion. Nous utilisons uniquement des cookies techniques ; aucun cookie publicitaire ni traceur tiers.
      </p>
    </div>
  </footer>
);

export default Footer;
